/* eslint-disable no-use-before-define */

document.addEventListener('DOMContentLoaded', () => {
  updateTranslations();

  const selectors = {
    iWishlistContainer: '#iwish-drawer-root',
    productContainer: '.productContainer',
    productCard: '.iwishProduct-row',
    caretIcon: '.mst-drawer-title-icon',
    backdrop: '.iwish-backdrop',
    closeIcon: '.icon.icon-close',
    atcButton: '.addToCart-btn',
    wishlistCount: '.iwish-counter',
    wishlistAddButton: '.iwish-app-block-product a',
    selectedSizeInput: '[data-option-position="2"] [data-single-option-selector]:checked',
  };

  // Observe the wishlist drawer for changes
  const drawerObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches(selectors.productContainer)) {
              handleProductsLoaded(mutation);
            } else if (node.matches(selectors.backdrop)) {
              handleDrawerOpen(mutation);
            }
          }
        });
      } else if (mutation.removedNodes.length) {
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches(selectors.productCard)) {
              // eslint-disable-next-line no-use-before-define
              handleProductsLoaded(mutation);
            }
          }
        });
      }
    });
  });

  if (document.querySelector(selectors.iWishlistContainer)) {
    drawerObserver.observe(document.querySelector(selectors.iWishlistContainer), {
      childList: true,
      subtree: true,
    });
  }

  // Observe the wishlist counters for changes
  const countObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            checkCounters();
          }
        });
      }
    });
  });

  if (document.querySelector(selectors.wishlistCount)) {
    [...document.querySelectorAll(selectors.wishlistCount)].forEach((count) => {
      countObserver.observe(count, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Observe the add to wishlist button for changes
  const addToWishlistObserver = new MutationObserver((mutations) => {
    mutations.forEach((_mutation) => {
      const mutation = _mutation;
      if (!mutation.target.querySelector('span')) return;

      if (!document.querySelector(selectors.selectedSizeInput) && !mutation.target.classList.contains('iwishAdded')) {
        mutation.target.querySelector('span').textContent = window.iWishData.select_size;
      } else if (mutation.target.dataset.variant === '') {
        mutation.target.querySelector('span').textContent = window.iWishData.variant_invalid;
      }
    });
  });

  if (document.querySelector(selectors.wishlistAddButton)) {
    [...document.querySelectorAll(selectors.wishlistAddButton)].forEach((button) => {
      addToWishlistObserver.observe(button, {
        childList: true,
        subtree: true,
      });
    });
  }

  function checkCounters() {
    const elements = {
      wishlistCounters: document.querySelectorAll(selectors.wishlistCount),
    };

    if (!elements.wishlistCounters.length) return;
    elements.wishlistCounters.forEach((_count) => {
      const count = _count;
      count.style.display = count.textContent === '0' ? 'none' : 'flex';
    });
  }

  function handleDrawerOpen(mutation) {
    const container = mutation.target.closest(selectors.iWishlistContainer);
    const elements = {
      caretIcon: container.querySelector(selectors.caretIcon),
      closeIcon: document.querySelector(selectors.closeIcon),
    };

    if (elements.closeIcon) {
      const closeIconClone = elements.closeIcon.cloneNode(true);
      elements.caretIcon?.querySelector('svg')?.remove();
      elements.caretIcon?.appendChild(closeIconClone);
    }
  }

  function handleProductsLoaded(mutation) {
    const elements = {
      products: mutation.target.querySelectorAll(selectors.productCard),
    };

    if (!elements.products.length) return;

    elements.products.forEach((_product) => {
      const product = _product;
      const imageColumn = product.querySelector('.col-3');
      const textColumn = product.querySelector('.col-9');
      imageColumn?.classList.add('col-4');
      imageColumn?.classList.remove('col-3');
      textColumn?.classList.add('col-8');
      textColumn?.classList.remove('col-9');

      if (product.querySelector('.price-regular')) {
        const values = [...product.querySelectorAll('.price-regular > span')].map((item) => item.textContent);

        // check if values are the same and remove the strikeThrough element
        if (values.length > 1 && values.every((val) => val === values[0])) {
          product.querySelector('.strikeThrough')?.remove();
        }
      }
    });
  }

  function updateTranslations() {
    const i18nNode = document.querySelector('[data-wishlist-translations]');
    if (!i18nNode) return;

    try {
      const translations = JSON.parse(i18nNode.textContent);
      Object.keys(translations).forEach((key) => {
        window.iWishData[key] = translations[key];
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error parsing wishlist translations:', error);
    }
  }
});
